/* Dos Piedras — comportamiento de la cabecera y carruseles */
(function () {
  var top = document.querySelector('[data-dp-top]');
  if (top) {
    var root = document.documentElement;
    var hasHero = !!document.querySelector('[data-dp-hero]');
    var zones = Array.prototype.slice.call(top.querySelectorAll('[data-dp-zone]'));
    var hover = false, mega = false, drawerOpen = false;

    function setHeight() {
      root.style.setProperty('--dp-top-h', top.offsetHeight + 'px');
      document.body.classList.toggle('dp-has-offset', !hasHero);
    }

    function toneAt(x, y) {
      var els = document.elementsFromPoint(x, y);
      for (var i = 0; i < els.length; i++) {
        if (top.contains(els[i])) continue;
        var t = els[i].closest('[data-tone]');
        if (t) return t.getAttribute('data-tone');
        var bg = getComputedStyle(els[i]).backgroundColor;
        if (bg && bg !== 'transparent' && bg.indexOf('rgba(0, 0, 0, 0)') !== 0) return 'light';
      }
      return 'light';
    }

    function update() {
      var solid = hover || mega || drawerOpen || !hasHero || window.scrollY > 24;
      top.classList.toggle('is-solid', solid);
      var bar = top.querySelector('.dp-bar').getBoundingClientRect();
      var y = bar.top + bar.height / 2;
      zones.forEach(function (z) {
        var r = z.getBoundingClientRect();
        if (!r.width) return;
        var dark = !solid && toneAt(r.left + r.width / 2, y) === 'dark';
        z.classList.toggle('dp-on-dark', dark);
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }

    top.addEventListener('mouseenter', function () { hover = true; update(); });
    top.addEventListener('mouseleave', function () { hover = false; update(); });

    var megaItem = top.querySelector('[data-dp-mega]');
    if (megaItem) {
      var trigger = megaItem.querySelector('a');
      megaItem.addEventListener('mouseenter', function () { mega = true; megaItem.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); update(); });
      megaItem.addEventListener('mouseleave', function () { mega = false; megaItem.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); update(); });
      megaItem.addEventListener('focusin', function () { mega = true; update(); });
      megaItem.addEventListener('focusout', function (e) { if (!megaItem.contains(e.relatedTarget)) { mega = false; update(); } });
    }

    var burger = top.querySelector('[data-dp-burger]');
    var drawer = top.querySelector('[data-dp-drawer]');
    if (burger && drawer) {
      burger.addEventListener('click', function () {
        drawerOpen = drawer.hasAttribute('hidden');
        if (drawerOpen) drawer.removeAttribute('hidden'); else drawer.setAttribute('hidden', '');
        burger.setAttribute('aria-expanded', String(drawerOpen));
        burger.setAttribute('aria-label', drawerOpen ? 'Cerrar menú' : 'Abrir menú');
        update();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { setHeight(); update(); });
    setHeight();
    update();
    window.addEventListener('load', function () { setHeight(); update(); });
  }

  /* Carruseles de producto */
  document.querySelectorAll('[data-dp-rail-wrap]').forEach(function (wrap) {
    var rail = wrap.querySelector('[data-dp-rail]');
    if (!rail) return;
    function step() {
      var card = rail.querySelector('.dp-card');
      return card ? card.getBoundingClientRect().width + 6 : rail.clientWidth / 3;
    }
    var prev = wrap.querySelector('[data-dp-prev]');
    var next = wrap.querySelector('[data-dp-next]');
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* Vídeos: asegurar reproducción silenciada */
  document.querySelectorAll('.dp-hero video').forEach(function (v) {
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  });
})();
